import React from 'react';
import './Footer.css';
import { FaInstagram, FaLinkedin, FaTwitter, FaFacebook } from 'react-icons/fa';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-links">
          <h3>Alpha Vomega</h3>
          <p>From chaos to clarity: Turning complexity into clarity.</p>
          <p style={{ marginTop: '8px', fontSize: '0.9rem', color: '#aaa' }}>Hyderabad, India</p>
        </div>
        <div className="footer-links">
          <h3>Quick Links</h3>
          <p><a href="#services" style={{ color: '#ccc', textDecoration: 'none' }}>Services</a></p>
          <p><a href="#about" style={{ color: '#ccc', textDecoration: 'none' }}>About</a></p>
          <p><a href="#career" style={{ color: '#ccc', textDecoration: 'none' }}>Careers</a></p>
          <p><a href="#contact" style={{ color: '#ccc', textDecoration: 'none' }}>Contact</a></p>
        </div>
        <div className="footer-links">
          <h3>Contact</h3>
          <p>info@alphavomega.com</p>
          <p>+91-8247667522</p>
        </div>
        <div className="footer-socials">
          <h3>Follow Us</h3>
          <div className="social-icons">
            <a href="https://www.instagram.com/" target="_blank" rel="noreferrer" aria-label="Instagram">
              <FaInstagram />
            </a>
            <a href="https://www.linkedin.com/" target="_blank" rel="noreferrer" aria-label="LinkedIn">
              <FaLinkedin />
            </a>
            <a href="https://twitter.com/" target="_blank" rel="noreferrer" aria-label="Twitter">
              <FaTwitter />
            </a>
            <a href="https://www.facebook.com/" target="_blank" rel="noreferrer" aria-label="Facebook">
              <FaFacebook />
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom-bar">
        <p>© 2026 Alpha Vomega. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
